import { Navigate, useLocation } from "react-router-dom";
import { useProfile } from "@/hooks/platform/useProfile";
import { LoadingState } from "@/components/dashboard/common/PageShell";

/**
 * Single entry point for direct messages. Every "Message" action across the
 * platform lands here and is forwarded to the Messages view inside whichever
 * role dashboard the signed-in user belongs to, keeping ?c= / ?to= intact.
 */
const Messages = () => {
  const { search } = useLocation();
  const { data, isLoading } = useProfile();

  if (isLoading) return <LoadingState label="Opening your messages…" />;

  const userType = data?.profile?.user_type;
  const role = userType === "creator" || userType === "venue" ? userType : "groover";
  return <Navigate to={`/dashboard/${role}/messages${search}`} replace />;
};

export default Messages;
